<template>
  <div class="nav-menu">
    <div class="nav-box">
      <div class="nav-left">
        <div
          class="logo"
          @click="
            toPathOrUrl({
              path: '/home'
            })
          "
        >
          <img src="/src/assets/images/logo.png" alt="logo" />
        </div>
        <div class="nav-list">
          <div
            class="nav-item"
            :class="{ active: isActive(item.path) }"
            v-for="item in navListLeft"
            :key="item.name"
            @click="toPathOrUrl(item)"
          >
            <img class="icon" :src="formatImage(item.name)" :alt="item.name" />
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="nav-right">
        <div class="nav-list">
          <div
            class="nav-item"
            :class="{ active: isActive(item.name) }"
            v-for="item in navListRight"
            :key="item.name"
            @click="toPathOrUrl(item)"
          >
            <img class="icon" :src="formatImage(item.name)" :alt="item.name" />
            {{ item.label }}
          </div>
        </div>
        <div class="user-info" v-if="userStore && userStore.token">
          <el-link :href="userStore.userInfo.isAdmin ? `${Config.baseUrl}/ssoLogin?token=${userStore.token}` : '#'">{{ userStore.userInfo.userName }}</el-link>
		  <span class="line">|</span>
          <el-link @click="logout">退出</el-link>
        </div>
		<template v-else>
			<el-button color="#1b1e23" @click="showLoginDialog">登录/注册</el-button>
		<!-- 	<span>|</span>
			<el-button color="#1b1e23" @click="toReg">注册</el-button> -->
		</template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { useUserStore } from '@/store/user.js'
import Config from '@/utils/config.ts'
const userStore = useUserStore()
const router = useRouter()
const route = useRoute()
// 导航栏左侧菜单
const navListLeft = reactive([
  {
    label: 'AI首页',
    name: 'home',
    path: '/home'
  },
  {
    label: 'AI图库',
    name: 'album',
    path: '/album'
  },
  {
    label: 'AI趋势',
    name: 'trend',
    path: '/trend'
  },
  {
    label: 'AI生图',
    name: 'generator',
    path: '/generator/imagine3'
  },
  {
    label: '创艺板',
    name: 'creative',
    path: '/generator/imagine1'
  }
])
// 导航栏右侧菜单
const navListRight = reactive([
  {
    label: 'CA9首页',
    name: 'ca9',
    link: 'https://www.ca9.cn/'
  },
  {
    label: '收藏',
    name: 'favorite',
    path: '/favorite'
  }
])
// 导航栏菜单路由切换
const toPathOrUrl = item => {
  if (item.link) {
    window.location.href = item.link
  } else {
    router.push({
      path: item.path
    })
  }
}
const formatImage = name => {
  // 直接返回绝对路径字符串，不使用 new URL(..., import.meta.url)，
  // 否则 Vite 会把整个 icon 目录 glob 打包并加 hash，导致线上无法动态替换
  return `/src/assets/images/icon/${name}.png`
}

// 判断当前路由是否激活
const isActive = path => {
  return route.path === path
}

// 登录弹窗唤起
const showLoginDialog = () => {
  userStore.openLoginDialog()
}
const toReg = () => {
  location.href = 'https://www.ca9.cn/index/license'
}
// 注销登录
const logout = () => {
  ElMessageBox.confirm('确定要退出登录吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    userStore.$reset()
    setTimeout(() => {
      window.location.reload()
    }, 200)
  })
}
</script>

<style lang="scss" scoped>
.nav-menu {
  position: sticky;
  top: 0;
  z-index: 999;
  .nav-box {
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    background: #fff;
    border-bottom: 1px solid #f1f1f1;
    z-index: 1000;
    position: relative;
    .nav-left {
      display: flex;
      align-items: center;
      cursor: pointer;
      .logo {
        color: #910a76;
        font-size: 24px;
        font-weight: 6000;
        margin-right: 20px;
      }
    }
    .nav-right {
      display: flex;
      align-items: center;
    }
    .nav-list {
      display: flex;
      .nav-item {
        display: flex;
        align-items: center;
        padding: 10px 20px;
        border-radius: 50px;
        font-weight: 600;
        transition: 0.3s;
        cursor: pointer;
        margin: 0 10px;
        white-space: nowrap;
        &.active,
        &:hover {
          background: linear-gradient(to right, #fedff8, #ffe9d7);
        }
        .icon {
          width: 21px;
          margin-right: 10px;
        }
      }
    }
    .user-info {
      @include flexBox(center, center);
      .line {
        margin: 0 10px;
      }
    }
  }
}
</style>
